export enum EntryType {
  Manual = 0,
  Automatic = 1,
  Correction = 2,
  TimeShift = 3
}

export const EntryTypeMapping: Record<EntryType, string> = {
  [EntryType.Manual]: 'Manual',
  [EntryType.Automatic]: 'Automatic',
  [EntryType.Correction]: 'Correction',
  [EntryType.TimeShift]: 'Date Shift'
};
